export default __webpack_public_path__ + "static/media/gift-card-redeem.0baff5ed.svg";